import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsReactProps } from 'echarts-for-react/lib/types';

import { adaptChartOption } from 'helper/echartsTheme';
import useChartTheme from 'hooks/theme/useChartTheme';
import useDocumentTheme from 'hooks/theme/useDocumentTheme';

/**
 * `ReactECharts` que segue o tema claro/escuro: aplica o tema ECharts (eixos, grade, tooltip,
 * legenda) e, no escuro, adapta as cores de série e descarta cor fixa de chrome do `option` —
 * inclusive do `option` que vem pronto do backend. Mesmas props do `echarts-for-react`.
 *
 * Migrar um gráfico: troque `import ReactECharts from 'echarts-for-react'` por
 * `import ReactECharts from 'components/ThemedECharts'`.
 */
export default function ThemedECharts({
  option,
  theme,
  ref,
  ...props
}: EChartsReactProps & { ref?: React.Ref<ReactECharts> }) {
  const documentTheme = useDocumentTheme();
  const chartTheme = useChartTheme();
  const themedOption = useMemo(
    () => adaptChartOption(option, documentTheme),
    [option, documentTheme],
  );
  return (
    // Repasse integral: é um wrapper fino do echarts-for-react, aceita exatamente as mesmas props.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ReactECharts ref={ref} option={themedOption} theme={theme ?? chartTheme} {...props} />
  );
}
